import { useUserStore } from '@unifyapps/carbon/auth/UserStoreProvider';
import { DrawerNavigation } from '@unifyapps/carbon/components/NavigationContainer/variants/DrawerNavigation';
import { EnabledUnOpenedNotification } from '@unifyapps/carbon/components/Notifications/components/EnabledUnOpenedNotification';
import type { InterfaceEntity, NavigationResolution } from '@unifyapps/defs/types/interface';
import { DrawerNavController } from './DrawerNavController';

type Props = {
  interfaceRecord: InterfaceEntity;
  resolution: NavigationResolution;
};

export function DrawerNav({ interfaceRecord, resolution }: Props) {
  const data = useUserStore().hooks.useCurrentUserDetails();
  const loggedInUserId = data?.user?.id;

  return (
    <EnabledUnOpenedNotification loggedInUserId={loggedInUserId}>
      {(unOpenedNotificationCount) => (
        <DrawerNavController
          interfaceRecord={interfaceRecord}
          resolution={resolution}
          unopenedNotificationsCount={unOpenedNotificationCount}
        >
          {/* @ts-expect-error app and navigation supplied by wrapper */}
          <DrawerNavigation />
        </DrawerNavController>
      )}
    </EnabledUnOpenedNotification>
  );
}
